import React, {PureComponent} from 'react';
import dayjs from 'dayjs';

import style from './LiveLinkItem.css'
import {avatarUrl, mediaName} from "../utils/helpers";
import YoutubeIcon from "./YoutubeIcon";
import RetweetIcon from "./RetweetIcon";


export default class LiveLinkItem extends PureComponent {
  render() {
    let {thread} = this.props;
    let {link} = thread;
    let {media} = link;

    return (
        <div className={style.live_link} id={'thread-' + thread.id}>
          <div>
            <h4 className={style.link_title}> {link.title} </h4>

            <div className={"d-flex " + style.summary_line}>
              {link.video_source ? <div className={style.link_video_placeholder} style={{
                // backgroundImage: `url(${avatarUrl(thread)})`
              }}>
                <a href={link.url} rel={'nofollow'} target='_blank'>
                  <YoutubeIcon size={40}/>
                </a>
              </div> : null}

              {link.description ?
                  <p className={style.link_summary}>
                    {link.description.substr(0, 200)}
                  </p>
                  : null}
            </div>

            <div className={style.footer}>
              <div className={style.byline}>
                <a href={link.url} target="_blank" rel="nofollow">{mediaName(thread)}</a>
                &nbsp; &nbsp;

                <time>
                  {dayjs(thread.publish_at).format('HH:mm')}
                </time>

                &nbsp; &nbsp;
                {/*{link.video_source ? <span>&nbsp;&nbsp;</span> : null}*/}
                {link.chars_count}字
                &nbsp;
                {link.is_original ? <span className="label-original"> 原创</span> : null}
                &nbsp;
                {/*&nbsp; &nbsp;*/}
                {/*{link.video_source ? <YoutubeIcon width={24} height={24}/> : null}*/}
              </div>

              {thread.duplications && thread.duplications.length ?
                  <div className={style.duplications}>
                    <RetweetIcon width={20} height={20} fill={'#888'}/>
                    {thread.duplications.map((duplication) => {
                      return <a href={duplication.link.url}
                                className={style.duplication_link}
                                data-toggle="tooltip"
                                title={duplication.link.title}
                                target="_blank"
                                rel="nofollow"><img src={avatarUrl(duplication)} width="24" height="24"/>
                      </a>
                    })}
                  </div> : null}

            </div>
          </div>

          <div className={'d-none d-sm-block ' + style.link_avatar}>
            <img src={avatarUrl(thread)} className="avatar" width="40" height="40"/>
          </div>

        </div>
    )
  }
}
